<form
	(ngSubmit)="onSubmit(nameForm)"
	#nameForm="ngForm"
	class="flex flex-col gap-2"
>
	<div *ngFor="let office of offices$ | async">
		<app-input
			[disabled]="!(admin$ | async)"
			[label]="office.officeName"
			[ngModel]="office.chicagoFirmName"
			[name]="office.id"
			orientation="row"
		></app-input>
	</div>
	<div class="flex justify justify-between mt-7" *ngIf="admin$ | async">
		<app-button (click)="close()" btn="tertiary" size="small">Close</app-button>
		<app-button type="submit" size="small">Save</app-button>
	</div>
</form>
<div *ngIf="!(admin$ | async)">
	<div class="mb-7 mt-3 border-b border-grey-veryLight w-full font-bold">
		Please contact an admin to set the office overrides
	</div>

	<app-contact-admin-users
		subject="Closer Admin help required: Chicago office override settings"
	></app-contact-admin-users>

	<div class="flex justify-end mt-5">
		<app-button (click)="close()" size="small">Close</app-button>
	</div>
</div>
